import React from 'react';
import { styles } from './phoneStyles';

export default function PhoneDetail({ detail, setDetail, displayMessages, isTyping, chatEndRef, handleChoice, newsComments, commentLog, answered }) {
  const renderNavBar = (title) => (
    <div style={styles.navBar}>
      <div style={styles.backBtn} onClick={() => setDetail(null)}><span style={{ fontSize: 16 }}>{"<"}</span> 返回</div>
      <div style={styles.navTitle}>{title}</div><div style={{ width: 50 }}></div>
    </div>
  );

  const renderChoices = (choices, targetId, senderOrNewsId, type) => {
    if (!choices || choices.length === 0 || answered[targetId]) return null;
    return (
      <div style={styles.choicesContainer}>
        {choices.map((c, i) => (
          <div key={i} style={styles.choiceBtn} onClick={() => handleChoice(c, targetId, senderOrNewsId, type)}>{c.text}</div>
        ))}
      </div>
    );
  };

  return (
    <div style={styles.detailWrapper}>
      {detail.type === 'mail' && (
        <>
          {renderNavBar("邮件正文")}
          <div style={{ padding: '0 5px', flex: 1, overflowY: 'auto' }}>
            <h3 style={{ color: '#fff', margin: '10px 0' }}>{detail.data.subject}</h3>
            <div style={{ color: '#ddd', fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{detail.data.body}</div>
          </div>
        </>
      )}

      {detail.type === 'sms' && (
        <>
          {renderNavBar(detail.data.sender)}
          <div style={styles.chatContainer}>
            {displayMessages.map(msg => (
              <div key={msg.id} style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={msg.isUser ? styles.chatBubbleUser : styles.chatBubbleNPC}>{msg.text}</div>
                {!msg.isUser && msg.choices && renderChoices(msg.choices, msg.id, detail.data.sender, 'sms')}
              </div>
            ))}
            {isTyping && <div style={{ ...styles.chatBubbleNPC, width: 40, textAlign: 'center' }}>...</div>}
            <div ref={chatEndRef} />
          </div>
        </>
      )}

      {detail.type === 'news' && (
        <>
          {renderNavBar("帖子详情")}
          <div style={{ padding: '0 5px', flex: 1, overflowY: 'auto' }}>
            <h3 style={{ color: '#fff', margin: '10px 0 5px 0', lineHeight: 1.4 }}>{detail.data.title}</h3>
            <div style={{ borderTop: '1px solid #333', paddingTop: 15, marginTop: 15 }}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 15 }}>热门评论：</div>
              {(newsComments[detail.data.id] || []).map((c, i) => (
                <div key={i} style={styles.commentItem}><span style={{ color: c.color }}>{c.author}：</span>{c.text}</div>
              ))}
              {renderChoices(detail.data.choices, detail.data.id, detail.data.id, 'news')}
              {(commentLog[detail.data.id] || []).map(comment => (
                <div key={comment.id} style={{ ...styles.commentItem, borderLeft: '3px solid #ff4081' }}><span style={{ color: '#ff4081' }}>{comment.author}：</span>{comment.text}</div>
              ))}
              <div ref={chatEndRef} />
            </div>
          </div>
        </>
      )}
    </div>
  );
}